module.exports = __webpack_public_path__ + "static/media/shape0_5.67c932c9.obj";